import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useClientRepresentativeSaveAddressesMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { AddressesWithFilesParam } from 'api/types/params/onboarding/addressesParam';
import { isFinanceProject } from 'config';

import { parseClientRepresentative } from './helpers/parseClientRepresentative';

export const useClientRepresentativeSaveAddresses = () => {
  const [handle, { data, loading, error: apolloError }] =
    useClientRepresentativeSaveAddressesMutation();

  const error = useError(apolloError);

  return {
    data: data?.clientRepresentativeSaveAddresses
      ? parseClientRepresentative(data.clientRepresentativeSaveAddresses)
      : undefined,
    loading,
    error,
    saveAddresses: useCallback(
      async (id: string, params: AddressesWithFilesParam) => {
        const res = await handle({
          variables: {
            id,
            input: {
              placeOfBirth: params.placeOfBirth,
              registrationAddress: isFinanceProject()
                ? params.registrationAddress
                : undefined,
              residentialAddress: params.residentialAddress,
            },
          },
        });
        return res?.data?.clientRepresentativeSaveAddresses
          ? parseClientRepresentative(
              res.data.clientRepresentativeSaveAddresses
            )
          : undefined;
      },
      [handle]
    ),
  };
};
